"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapMediaInfoToLiveVideoStatus = void 0;
var api_types_1 = require("@wix/wix-vod-constants/api-types");
var common_1 = require("@wix/wix-vod-constants/common");
var mapMediaInfoToLiveVideoStatus = function (mediaInfo, itemType) {
    var _a, _b;
    var status = (_b = (_a = mediaInfo === null || mediaInfo === void 0 ? void 0 : mediaInfo.fileOutput) === null || _a === void 0 ? void 0 : _a.video[0]) === null || _b === void 0 ? void 0 : _b.status;
    var isLiveVideo = itemType === api_types_1.ItemType.ItemLive;
    return isLiveVideo ? common_1.LIVE_VIDEO_STATUS[status] : undefined;
};
exports.mapMediaInfoToLiveVideoStatus = mapMediaInfoToLiveVideoStatus;
//# sourceMappingURL=mapMediaInfoToLiveStatus.js.map